import type { Snapshot } from './types';
export interface Repository {
  read(): Promise<Snapshot | undefined>;
  change(
    update: (current: Snapshot | undefined) => Snapshot,
  ): Promise<Snapshot>;
}
const openDatabase = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open('srbs-prototype', 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains('snapshots'))
        db.createObjectStore('snapshots');
    };
    request.onsuccess = () => {
      const db = request.result;
      db.onversionchange = () => db.close();
      resolve(db);
    };
    request.onerror = () =>
      reject(new Error('本地存储不可用，请检查浏览器设置或存储空间。'));
    request.onblocked = () =>
      reject(new Error('数据升级被其他标签页阻塞，请关闭旧页面后重试。'));
  });
export function indexedRepository(namespace: string): Repository {
  let connection: Promise<IDBDatabase> | undefined;
  const database = () => {
    connection ??= openDatabase();
    return connection;
  };
  return {
    async read() {
      const db = await database();
      return new Promise((resolve, reject) => {
        const tx = db.transaction('snapshots', 'readonly');
        const request = tx.objectStore('snapshots').get(namespace);
        request.onsuccess = () => {
          resolve(request.result);
        };
        request.onerror = () => reject(request.error);
      });
    },
    async change(update) {
      const db = await database();
      return new Promise((resolve, reject) => {
        const tx = db.transaction('snapshots', 'readwrite');
        const store = tx.objectStore('snapshots');
        const request = store.get(namespace);
        let next: Snapshot;
        let error: unknown;
        request.onsuccess = () => {
          try {
            next = update(request.result);
            store.put(next, namespace);
          } catch (e) {
            error = e;
            tx.abort();
          }
        };
        tx.oncomplete = () => resolve(next);
        tx.onerror = () =>
          reject(
            error ||
              new Error('保存失败，本地存储空间可能不足。输入尚未提交。'),
          );
        tx.onabort = () =>
          reject(error || new Error('本次操作未保存，请重试。'));
      });
    },
  };
}
